import { Grid } from "@mui/material";
import { isUndefined, kebabCase } from "lodash";
import { useStyles } from "./styles";

type Item = {
  label: string | React.ReactElement;
  value?: string | number | React.ReactElement;
};

interface Props {
  title: string;
  items: Item[];
}

export const DetailsTable = ({ title, items }: Props) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid className={classes.item} item xs={12}>
        <span
          className={classes.header}
          data-test-id={`section-header-${kebabCase(title)}`}
        >
          {title}
        </span>
        {items.map(({ label, value }, index) => (
          <span className={classes.itemContent} key={index}>
            <span
              className={classes.itemName}
              data-test-id={`section-${kebabCase(title)}-${index}-label`}
            >
              {label}
            </span>
            <span
              className={classes.itemValue}
              data-test-id={`section-${kebabCase(title)}-${index}-value`}
            >
              {isUndefined(value) ? "-" : value}
            </span>
          </span>
        ))}
      </Grid>
    </Grid>
  );
};
